import * as angular from 'angular';

(function () {
    'use strict';

    angular.module('app').component('imIssueFormCategory', {
        template:
            require('/builds/imieszkaniec.pl/iwykonawca/frontend/src/app/components/issues/issue_forms/fragments/category/issue_form_category.html'),
        controller: 'IssueFormCategoryController',
        controllerAs: 'IssueFormCategoryCtrl',
        bindings: {
            isFullWidth: '<', // boolean
            category: '=',
            clientId: '<',
        },
    });
})();



// WEBPACK FOOTER //
// ./node_modules/angularjs-template-loader??ref--0-1!./src/app/components/issues/issue_forms/fragments/category/issue_form_category.component.ts